

















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
    },
    data: function() {
        return {
            pathInStore: "property.outdoor.terrace.orientation",
            options: [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("north"),
                    "value": "NORTH"
                },
                {
                    "label": this.$t("south"),
                    "value": "SOUTH"
                },
                {
                    "label": this.$t("east"),
                    "value": "EAST"
                },
                {
                    "label": this.$t("west"),
                    "value": "WEST"
                },
                {
                    "label": this.$t("north_east"),
                    "value": "NORTH_EAST"
                },
                {
                    "label": this.$t("north_west"),
                    "value": "NORTH_WEST"
                },
                {
                    "label": this.$t("south_east"),
                    "value": "SOUTH_EAST"
                },
                {
                    "label": this.$t("south_west"),
                    "value": "SOUTH_WEST"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.outdoor.terrace.exists") === true;
        },
        terraceOrientation: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateTerraceOrientation: function(value: string): void {
            if (value != "") {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": value});

            } else if (value == "" &&
                this.$store.getters["FormModule/getValue"](this.pathInStore) != null
            ) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
        }
    },

});

